<template>
  <div>
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-4">
        <strong>Napravite nalog</strong>
      </div>
      <div class="mb-4">
        <p>
          Upravljajte kadrovima na efikasan način i uštedite vrijeme za više poslovnih uspjeha.
        </p>
      </div>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            size="large"
            placeholder="Puno ime i prezime"
            v-decorator="['name', {rules: [{ required: true, message: 'Unesite vaše ime i prezime' }]}]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="Email Adresa"
            v-decorator="['email', {rules: [{ required: true, message: 'Unesite vašu email adresu' }]}]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            type="password"
            placeholder="Lozinka"
            v-decorator="['password', {rules: [{ required: true, message: 'Unesite željenu lozinku' }]}]"
          />
        </a-form-item>
        <a-button
          type="primary"
          size="large"
          class="text-center w-100"
          :loading="loading"
          htmlType="submit"
        >
          <strong>Registracija</strong>
        </a-button>
      </a-form>
      <div>
        <span class="mr-1">Klikom na registracija saglasni ste sa</span>
        <a href="javascript: void(0);" class="kit__utils__link">Uslovima korštenja</a> i
        <a href="javascript: void(0);" class="kit__utils__link">Politikom privatnosti</a>
      </div>
    </div>
    <div class="text-center pt-2 mb-auto">
      <span class="mr-2">Već imate nalog?</span>
      <router-link to="/auth/login" class="kit__utils__link font-size-16">Prijavite se</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CuiRegister',
  computed: {
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$store.dispatch('user/REGISTER', { payload: values })
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>
